import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { sidebarConfig } from '@backstage/core-components';
import { TOPBAR_HEIGHT } from './topBarLayout';
import { TopBarSearch } from './TopBarSearch';
import { TopBarUserMenu } from './TopBarUserMenu';
import { HeaderHelpButton } from './HeaderHelpButton';
import { NotificationBell } from '../../plugins/notifications/components/NotificationBell';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    top: 0,
    left: sidebarConfig.drawerWidthOpen,
    right: 0,
    height: TOPBAR_HEIGHT,
    // Deliberately *not* higher than the sidebar's own z-index (see
    // modules/topBar.tsx, which pins the sidebar above this) — the sidebar
    // and its logo must never end up hidden behind this bar.
    zIndex: theme.zIndex.appBar,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(0, 3),
    // A white console bar sitting above the warm-canvas content area, same
    // "paper" surface every card/table on the page uses — not the page's
    // own canvas color, so the bar reads as one fixed console chrome piece.
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.border}`,
    '@media print': {
      display: 'none',
    },
  },
  side: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    flex: '0 0 auto',
  },
  center: {
    flex: '1 1 auto',
    display: 'flex',
    justifyContent: 'center',
  },
}));

// The persistent bar sitting above the content area — global search and the
// user menu (moved here from the bottom of the sidebar, see
// TopBarUserMenu). Starts at the sidebar's pinned-open width
// (sidebarConfig.drawerWidthOpen) rather than dynamically measuring it — an
// earlier version tried to observe the sidebar's real DOM width so this
// would also track its collapsed (icon-only) state, but that measurement
// kept landing wrong in practice (the sidebar can mount after this
// component, behind a Suspense boundary) and hid the logo behind this bar.
// This app's sidebar is shown pinned-open in every real screenshot we've
// checked, so a static value is the more reliable choice — the trade-off
// is a harmless gap (not an overlap) if a user ever collapses it.
export const TopBar = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.center}>
        <TopBarSearch />
      </Box>
      <Box className={classes.side} style={{ justifyContent: 'flex-end' }}>
        <HeaderHelpButton />
        <NotificationBell />
        <TopBarUserMenu />
      </Box>
    </Box>
  );
};
